<template>
	<div class="container-fluid admin">
		<navigation-admin></navigation-admin>
		<div class="row row-fluid wrapper-flexbox">
			<sidebar-admin></sidebar-admin>
			<section class="col-sm-10 admin-background-shadow overflow">
				<div class="row">
					<div class="col-sm-2">
						<p class="admin-header">Usuarios</p>
					</div>
				</div>
				<div class="row row-fluid absolute">
					<div class="col-sm-12">
						<div class="table-responsive">
						<table-admin-users :list="render_users" :url="url" :remove="remove"></table-admin-users>
						<div v-if="!render_users.length" class="text-center empty">No hay usuarios en la plataforma.</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import navigationAdmin from '../../components/Admin/Admin-navigation.vue';
import sidebarAdmin from '../../components/Admin/Admin-sidebar.vue';
import tableAdminUsers from '../../components/Admin/Admin-table-users.vue';
import { confirm } from '../../scripts/confirm';
import { deleteUser } from '../../store/actions';

export default {
	// ------ DATA ------

	data() {
		return {
			url: '/admin/users/edit/'
		};
	},

	// ------ VUEX ------

	vuex: {
		getters: {
			users: state => state.users,
			current_user: state => state.current_user
		},
		actions: {
			deleteUser
		}
	},

	// ------ RENDER ------

	computed: {
		render_users() {
			return this.users;
		}
	},

	// ------ METHODS ------

	methods: {
		remove(user) {
			const vm = this;

			confirm({
				title: 'Eliminar Usuario',
				content: 'Seguro que quieres eliminar a ' + user.name,
				
				confirm: function () {
					// send the user that is going to remove.
					// Send the admin to obtain his token to procced, and 
					vm.deleteUser(vm.current_user, user);
				},

				cancel: function () {

				}
			});
		}
	},

	// ------ COMPONENTS ------
  
  components: {
    navigationAdmin,
    sidebarAdmin,
    tableAdminUsers,
  }
};
</script>


// WEBPACK FOOTER //
// Admin-users.vue?6f83af1a